import { useCallback } from 'react'

import { useDispatch, useSelector } from 'react-redux'

import { RootState } from '../redux/store'

import { getZonesActionAsync } from '../redux/actions/zoneActions'

export const useZones = () => {
  const dispatch = useDispatch()
  const { zonesState } = useSelector((state: RootState) => state.zone)

  const getZones = useCallback(() => {
    dispatch(getZonesActionAsync())
  }, [dispatch])

  return { zonesState, getZones }
}
